import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { VideoProviderList, VideoProviderEdit } from 'src/app/video-provider/model/video-provider';
import { CacheBuster } from 'ts-cacheable';

const videoProvidersCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class VideoProviderService
{

  constructor(private http: HttpClient) { }

  /**
   * Delete a Video Provider.
   *
   * @param id Video Provider id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: videoProvidersCacheBuster
    })
  public deleteVideoProvider(id: number): Observable<VideoProviderEdit>
  {
    return this.http.delete<VideoProviderEdit>(`/video/provider/${id}`);
  }

  /**
   * Save a Video Provider.
   *
   * @param data Video Provider to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: videoProvidersCacheBuster
    })
  public saveVideoProvider(data: any, isNew: boolean, videoProviderId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/video/provider', data);
    }
    else
    {
      return this.http.put(`/video/provider/${videoProviderId}`, data);
    }
  }

  /**
   * Get Video Providers.
   */
  public getVideoProvidersList(): Observable<VideoProviderList[]>
  {
    return this.http.get<VideoProviderList[]>('/video/providers/list');
  }

  /**
   * Check if Video Provider is in use
   *
   * @param id Video Provider Id
   */
  public existsVideoProvider(id: number): Observable<any>
  {
    return this.http.get(`/video/provider/inuse/${id}`);
  }

  /**
   * Check if Video Provider Name exists to avoid name duplicates
   *
   * @param name Video Provider Name
   */
  public existsVideoProviderName(name: string): Observable<any>
  {
    return this.http.get(`/video/provider/exists?name=${name}`);
  }

  /**
   * Get a Video Provider by id.
   *
   * @param id Video Provider id
   */
  public getVideoProviderById(id: number): Observable<VideoProviderEdit>
  {
    return this.http.get<VideoProviderEdit>(`/video/provider/${id}`);
  }
}
